module.exports = __webpack_public_path__ + "resources/img/career-devImg.6abe287b.png";